export const statusLabels = {
  normal: "Pa afat", upcoming: "Në vijim", dueToday: "Sot", overdue: "I vonuar", completed: "Përfunduar",
};
export const statusColor = status => ({ overdue: "error", dueToday: "warning", completed: "success", upcoming: "info" }[status] || "default");
export const formatNoteDate = value => value
  ? new Intl.DateTimeFormat("sq-AL", { dateStyle: "medium", timeStyle: "short" }).format(new Date(value)) : "—";
export function toLocalInput(value) {
  if (!value) return "";
  const d = new Date(value);
  const pad = n => String(n).padStart(2, "0");
  return `${d.getFullYear()}-${pad(d.getMonth() + 1)}-${pad(d.getDate())}T${pad(d.getHours())}:${pad(d.getMinutes())}`;
}
export function notePayload(form) {
  const title = form.Title.trim();
  if (!title || title.length > 200) throw new Error("Titulli është i detyrueshëm dhe lejon deri në 200 karaktere.");
  let deadline = null;
  if (form.DeadlineDate) {
    const date = new Date(form.DeadlineDate);
    if (!Number.isFinite(date.getTime()) || toLocalInput(date) !== form.DeadlineDate)
      throw new Error("Data ose ora nuk është valide në zonën tuaj kohore.");
    deadline = date.toISOString();
  }
  return { Title: title, Content: form.Content || null, DeadlineDate: deadline, IsPinned: !!form.IsPinned };
}
